export default function() {
    const days_in_month = [];
    for (let i = 1; i <= 31; i++) {
        days_in_month.push(('0' + i).slice(-2));
    }

    const years = [];
    for (let i = new Date().getFullYear(); i > 1899; i--) {
        years.push(i);
    }

    return {
        _id: '',
        registration_code: '',
        email: "",
        otp: null,
        terms_of_service: false,
        university_student: false,
        employee: false,
        f_name: "",
        l_name: "",
        company: "",
        employer: "",
        title: "",
        company_role_id: "",
        department_id: "",
        university: "",
        degree: "",
        phone: "",
        std_code: "",
        birth_date: "",
        birth_month: "",
        birth_year: "",
        days_in_month: Object.freeze(days_in_month),
        years: Object.freeze(years),
        month_names: [{
                name: "January",
                value: "01"
            },
            {
                name: "February",
                value: "02"
            },
            {
                name: "March",
                value: "03"
            },
            {
                name: "April",
                value: "04"
            },
            {
                name: "May",
                value: "05"
            },
            {
                name: "June",
                value: "06"
            },
            {
                name: "July",
                value: "07"
            },
            {
                name: "August",
                value: "08"
            },
            {
                name: "September",
                value: "09"
            },
            {
                name: "October",
                value: "10"
            },
            {
                name: "November",
                value: "11"
            },
            {
                name: "December",
                value: "12"
            }
        ],
        country: "",
        province: "",
        city: "",
        timezone: "",
        profile_image: null,
        profile_photo: null,
        profile_photo_base64: null,
        password: "",
        confirm_password: "",
        email_look_up: false,
        emailLookUp: null,
        step: 1,
        roles: [],
        departments: [],
        role_name: "",
        uploadImageModal: false,
    }
}
